import React from 'react'
import LocalVehicleDetail from './detail-page/LocalVehicleDetail'

const LocalVehicle = () => {
  return (
    <LocalVehicleDetail />
  )
}

export default LocalVehicle